<template>
  <div id="whs" ref="whs">
    <!-- <link href="../node_modules/fa/css/all.css" rel="stylesheet"> -->

    <Error v-if="isError('Access denied')" code="Access denied" />
    <router-view v-else></router-view>
  </div>
</template>

<script>
import Error from '@/components/Error.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  components: {
    Error,
  },
  computed: {
    ...mapActions(['authorize']),
    ...mapState(['modal']),
    ...mapGetters(['context', 'isError'])
  },
  mounted: function () {
    this.$store.dispatch('authorize').then(() => this.useColorTheme());
    // if (!authorized) {
    //   return;
    // }
    // console.log(authorized);
    this.$store.commit('setRoute', this.$route.path);
  },
  watch: {
    modal: function (value) {
      document.body.style.overflow = document.documentElement.style.overflow = value
        ? 'hidden'
        : '';
    },
    $route: function (route) {
      this.$store.commit('setModal', false);

      if (route.path === '/') this.$store.commit('hero/minify', false);
      else this.$store.commit('hero/minify');

      this.$store.commit('setRoute', route.path);
    }
  },
  methods: {
    useColorTheme() {
      if (this.context === 'office' || this.context === 'td') {
        document.documentElement.style.setProperty('--color-bg', '#efefef');
        document.documentElement.style.setProperty('--color-bg-dark', '#ccc');
        document.documentElement.style.setProperty('--color-alt-5', '#6666');
        document.documentElement.style.setProperty('--color-text', '#222');
        document.documentElement.style.setProperty('--color-text-5', '#222a');
        this.$refs.whs.style.setProperty('font-family', 'Roboto, sans-serif');
      }
      if (this.context === 'pm' || this.context === 'main-pm') {
        document.documentElement.style.setProperty('--color-text', '#222');
        document.documentElement.style.setProperty('--color-text-5', '#222a');
        document.documentElement.style.setProperty('--color-button', '#e4042a');
        document.documentElement.style.setProperty(
          '--color-button-hover',
          '#444'
        );
        document.documentElement.style.setProperty('--color-main', '#e4042a');
        document.documentElement.style.setProperty('--color-alt', '#f7ce00');
        document.documentElement.style.setProperty(
          '--color-alt-5',
          '#f7ce00aa'
        );
        document.documentElement.style.setProperty(
          '--color-second-alt',
          '#ff8b9e'
        );
        document.documentElement.style.setProperty('--color-bg', '#fff7ce');
        document.documentElement.style.setProperty(
          '--color-bg-dark',
          '#fff3b5'
        );
      }
    }
  }
};
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
}

:root {
  --color-paper: white;
  --color-main: #06b;
  --color-second: #ef4123;
  --color-second-alt: #fff200;
  --color-third: #ef9923;
  --color-third-5: #ef992350;
  --color-alt: #0af;
  --color-alt-5: #00aaff50;
  --color-bg: #e3f6ff;
  --color-bg-dark: #cfefff;
  --color-text: #035;
  --color-text-cold: #0a3;
  --color-bg-warm: #f1abd2;
  --color-bg-cold: #43da70;
  --color-bg-cold-5: #43da7050;
  --color-text-5: #035c;
  --color-button: linear-gradient(var(--color-alt) -50%, var(--color-main));
  --color-button-hover: linear-gradient(to top,
      var(--color-second) -20%,
      var(--color-second-alt) 150%);
}

#whs {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 14px;
  color: var(--color-text);
}

#whs * {
  box-sizing: border-box;
}

.whs-icon:before,
.whs-icon-left:before {
  content: '\f072';
  width: 14px;
  font: 900 normal normal 14px/1 'Font Awesome 5 Pro';
  font-size: 14px;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: var(--color-alt-5);
  transition: 0.3s ease-out;
}

.whs-icon-left:before {
  margin: 1px 14px 0 0;
}

.whs-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-bg);
  /* overflow: hidden; */
}

.whs-layout-row {
  width: 100%;
  max-width: 1200px;
  /* margin: -12px; */
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
}

.whs-sidebar {
  padding: 12px;
  flex: 1 1 260px;
}

.whs-content {
  padding: 12px;
  flex: 3 3 840px;
}

.whs-small {
  font-size: 12px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.whs-button-main,
.whs-button-second,
.whs-button-third {
  width: 100%;
  background: var(--color-button);
  outline: none;
  padding: 7px 14px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.whs-button-second {
  background: var(--color-bg-dark);
  border-bottom-color: var(--color-alt-5);
  color: var(--color-main);
}

.whs-button-third {
  background: #fff;
  color: var(--color-main);
  padding: 6px 13px;
  border: 1px solid var(--color-alt-5);
  border-bottom: 2px solid var(--color-alt-5);
  width: unset;
  display: inline-flex;
}

.whs-button-main:hover {
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-second-alt);
}

.whs-button-second:hover {
  background: var(--color-bg);
  border-bottom-color: var(--color-bg-dark);
  color: var(--color-alt);
}

.whs-button-third:hover {
  background: var(--color-bg);
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.whs-row {
  display: flex;
  flex-wrap: wrap;
}

.whs-form-checkbox {
  cursor: pointer;
  display: flex;
  padding: 2px 0;
  transition: 0.1s;
}

.whs-form-checkbox:before {
  content: '\f0c8';
  font-weight: 300;
  font-size: 18px;
  color: var(--color-alt-5);
  margin-right: 8px;
  transition: 0.1s;
}

.whs-form-checkbox.whs-checked {
  font-weight: 700;
  color: var(--color-main);
  transition: 0.1s;
}

.whs-form-checkbox.whs-checked:before {
  content: '\f14a';
  font-weight: 700;
  color: var(--color-alt);
  transition: 0.1s;
}

.whs-red,
.whs-red:before {
  color: var(--color-second);
}
</style>
